import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useReducer } from 'react';
const defaultState = {
    login: {
        email: '',
        registrationPassed: false,
    },
};
const CheckoutConfigContext = createContext({});
export const useCheckoutConfig = () => {
    const context = useContext(CheckoutConfigContext);
    if (context === undefined) {
        throw new Error('useCheckoutConfig must be used within CheckoutConfigContext Provider');
    }
    return context;
};
const CheckoutStateContext = createContext([]);
export const useCheckoutState = () => {
    const context = useContext(CheckoutStateContext);
    if (context === undefined) {
        throw new Error('useCheckoutState must be used within CheckoutStateContext Provider');
    }
    return context;
};
const reducer = (state, action) => {
    switch (action.type) {
        case 'update_login_data':
            return Object.assign(Object.assign({}, state), { login: Object.assign(Object.assign({}, state.login), action.payload) });
        case 'registration_passed':
            return Object.assign(Object.assign({}, state), { login: Object.assign(Object.assign({}, state.login), { registrationPassed: true }) });
        default:
            return state;
    }
};
export const CheckoutProvider = ({ children, config, }) => {
    return (_jsx(CheckoutConfigContext.Provider, { value: config, children: _jsx(CheckoutStateContext.Provider, { value: useReducer(reducer, Object.assign({}, defaultState)), children: children }) }));
};
